module.exports = __webpack_public_path__ + "img/hypothesis_developer_key.0d0a82ba.png";